module.exports = __webpack_public_path__ + "img/170.4ed6e323.jpg";